"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassicLayout = void 0;

var _palette = require("@artsy/palette");

var _Share = require("../Byline/Share");

var _Constants = require("../Constants");

var _Header = require("../Header/Header");

var _Sections = require("../Sections/Sections");

var _react = _interopRequireDefault(require("react"));

var _CanvasFooter = require("./Components/CanvasFooter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassicLayout = function ClassicLayout(props) {
  var _props$article = props.article,
      slug = _props$article.slug,
      social_title = _props$article.social_title,
      thumbnail_title = _props$article.thumbnail_title;
  return _react.default.createElement(_palette.Box, {
    position: "relative",
    pt: (0, _palette.space)(2),
    pb: (0, _palette.space)(4)
  }, _react.default.createElement(_Header.Header, props), _react.default.createElement(_Sections.Sections, props), _react.default.createElement(_palette.Box, {
    maxWidth: 580,
    mx: "auto",
    px: [(0, _palette.space)(2), 0]
  }, _react.default.createElement(_Share.Share, {
    hasLabel: true,
    url: (0, _Constants.getArticleFullHref)(slug),
    title: social_title || thumbnail_title
  })), _react.default.createElement(_CanvasFooter.CanvasFooter, {
    article: props.article,
    relatedArticles: props.article.relatedArticles
  }));
};

exports.ClassicLayout = ClassicLayout;
//# sourceMappingURL=ClassicLayout.js.map